<template>
  <v-stepper v-model="stage">
    <v-stepper-header>
      <v-stepper-step :complete="stage > 1" step="1">
        Dados
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="stage > 2" step="2">
        Efeitos
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="stage > 3" step="3">
        Despesa
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="4">
        Arquivos
      </v-stepper-step>
    </v-stepper-header>

    <v-container mt-4 justify-center class="container-stepper-item">
      <v-stepper-items>
        <v-stepper-content step="1">
          <!-- <div v-if="this.$store.state.isCnpj === false"> -->
          <div>
            <main-data :departments="departments" @next="goToNext" />
          </div>
          <!-- <div v-else>
            <main-data :entities="entities" @next="goToNext" />
          </div> -->
        </v-stepper-content>

        <v-stepper-content step="2">
          <effects @next="goToNext" @previous="goToPrevious" />
        </v-stepper-content>

        <v-stepper-content step="3">
          <investment
            @next="goToNext"
            @previous="goToPrevious"
            @saveProject="save"
          />
        </v-stepper-content>

        <v-stepper-content step="4">
          <file-handler
            @finish="goToProjects"
            @previous="goToPrevious"
            @saveProject="save"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-container>
  </v-stepper>
</template>

<script>
import api from '@/services/api';
import getErrorMessage from '@/utils/getErrorMessage';
import Project from '@/models/Project';
import Price from '@/models/Price';
import File from '@/models/File';
import MainData from './MainData';
import Effects from './Effects';
import FileHandler from './FileHandler';
import Investment from './Investment';

export default {
  components: { MainData, Effects, FileHandler, Investment },

  data() {
    return {
      stage: 1,
      departments: [],
      entities: [],
    };
  },

  methods: {
    goToProjects() {
      this.$store.dispatch('saveOriginalProject', new Project());
      this.$store.dispatch('saveOriginalPrices', [new Price()]);
      this.$store.dispatch('saveOriginalFiles', [new File()]);
      this.$router.push('/projects');
    },
    goToNext() {
      this.stage += 1;
      window.scrollTo({ top: 66, behavior: 'smooth' });
    },
    goToPrevious() {
      this.stage -= 1;
      window.scrollTo({ top: 66, behavior: 'smooth' });
    },
    updateStateProject(after, before) {
      const toBeUpdated = before;
      toBeUpdated.id = after.id;
      toBeUpdated.prices = after.prices;
      this.$store.dispatch('editProject', toBeUpdated);
    },
    async save({ project, next }) {
      try {
        this.$store.dispatch('loading', true);

        let verb = '';
        let response = {};

        if (project.id) {
          response = await api.put(`/projects/${project.id}`, project);
          verb = 'atualizado';
        } else {
          response = await api.post('/projects', project);
          verb = 'salvo';
        }

        this.updateStateProject(response.data.data, project);
        if (next) {
          this.goToNext();
        }

        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: `Projeto ${verb} com sucesso`,
        });
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async listDepartments() {
      let departments = [];

      try {
        this.$store.dispatch('loading', true);

        const departmentsResponse = await api.get('/projects/departments');

        if (departmentsResponse && departmentsResponse.data) {
          departments = departmentsResponse.data.departments;
        }

        if (!departments || !departments.length) {
          this.departments = [];
          return;
        }
        this.departments = departments;
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async listEntities() {
      let entities = [];

      try {
        this.$store.dispatch('loading', true);

        const entitiesResponse = await api.get('/projects/entities');

        if (entitiesResponse && entitiesResponse.data) {
          entities = entitiesResponse.data.entities;
        }

        if (!entities || !entities.length) {
          this.entities = [];
          return;
        }
        this.entities = entities;
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    handleScroll() {
      const stepperHeader = document.querySelector('.v-stepper__header');
      if (window.pageYOffset > 64) {
        stepperHeader.classList.add('sticky');
      } else {
        stepperHeader.classList.remove('sticky');
      }
    },
  },

  created() {
    // if (this.$store.state.isCnpj === false) {
      this.listDepartments();
    // } else {
    //     this.listEntities();
    // }
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
.container-stepper-item {
  max-width: 720px;
}
.col-button {
  flex-grow: unset;
  padding: 0 16px 16px;
}
.v-stepper__wrapper {
  overflow: unset !important;
}
.v-stepper__header {
  z-index: 1 !important;
  background-color: var(--v-background-base) !important;
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}
.sticky + .container {
  padding-top: 84px;
}
</style>
